function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st0",
  d: "M13.1,0l1.7,2.9l3.3,0.7L17.8,7L20,9.5L17.8,12l0.3,3.3l-3.3,0.7L13.1,19L10,17.7L6.9,19 l-1.7-2.9l-3.3-0.7L2.2,12L0,9.5L2.2,7L1.9,3.6l3.3-0.7L6.9,0L10,1.3L13.1,0z M12.3,2.3L10.7,3L10,3.3L9.3,3L7.7,2.3L6.8,3.8 L6.4,4.5L5.6,4.7L3.9,5L4,6.8l0.1,0.8L3.6,8.2L2.4,9.5l1.2,1.3l0.5,0.6L4,12.2L3.9,14l1.7,0.4l0.8,0.2l0.4,0.7l0.9,1.5L9.3,16 l0.7-0.3l0.7,0.3l1.6,0.7l0.9-1.5l0.4-0.7l0.8-0.2l1.7-0.4L16,12.2l-0.1-0.8l0.5-0.6l1.2-1.3l-1.2-1.3l-0.5-0.6L16,6.8L16.1,5 l-1.7-0.4l-0.8-0.2l-0.4-0.7L12.3,2.3z M13,9c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S11.9,9,13,9z M13,6l-4,7H7l4-7H13z M7,6 c1.1,0,2,0.9,2,2s-0.9,2-2,2S5,9.1,5,8S5.9,6,7,6z"
});

var SvgCommission = function SvgCommission(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 19",
    style: {
      enableBackground: "new 0 0 20 19"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommission, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/commission.7a628bae.svg";
export { ForwardRef as ReactComponent };